'use client';

import { useForm, Controller, type SubmitHandler } from 'react-hook-form';
import { useRouter } from 'next/navigation';
import { z } from 'zod';
import { Input } from '@axa/design-system';
import { zodResolver } from '@hookform/resolvers/zod';

const searchSchema = z.object({
  search: z.string().min(1, 'Por favor, digite uma pergunta, assunto ou problema')
});

type SearchData = z.infer<typeof searchSchema>;

type SearchInputFormProps = {
  defaultValue?: string;
};

export const SearchInputForm = ({ defaultValue }: SearchInputFormProps) => {
  const router = useRouter();
  const { control, handleSubmit } = useForm<SearchData>({
    resolver: zodResolver(searchSchema),
    defaultValues: {
      search: defaultValue || ''
    }
  });

  const handleSearchSubmit: SubmitHandler<SearchData> = (data) => {
    router.push(`/central-de-ajuda/busca?search=${data.search}`);
  };

  return (
    <form className="m-auto max-w-[684px] py-10" onSubmit={handleSubmit(handleSearchSubmit)}>
      <Controller
        control={control}
        name="search"
        render={({ field, formState }) => (
          <Input
            leftIcon={{
              name: 'Search'
            }}
            placeholder="Digite uma pergunta, assunto ou problema ..."
            autoComplete="off"
            hasError={!!formState.errors.search?.message}
            {...field}
          />
        )}
      />
    </form>
  );
};
